import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'ERROR';

i18next.addResources('es', NAMESPACE, {
  ERROR_TITLE: 'Error',
  OOPS: 'Oops!',
  GO_BACK: 'Volver al inicio',
  NOT_FOUND: 'Página no encontrada',
  MAINTENANCE_PAGE_TITLE: 'En mantenimiento',
  MAINTENANCE_TITLE: 'Temporalmente fuera de servicio por mantenimiento',
  MAINTENANCE_DESCRIPTION:
    'Estamos realizando un mantenimiento programado. Estaremos de vuelta en línea en breve.',
});

i18next.addResources('en', NAMESPACE, {
  ERROR_TITLE: 'Error',
  OOPS: 'Oops!',
  GO_BACK: 'Back to home',
  NOT_FOUND: 'Page not found',
  MAINTENANCE_PAGE_TITLE: 'In maintenance',
  MAINTENANCE_TITLE: 'Temporarily down for maintenance',
  MAINTENANCE_DESCRIPTION:
    'We are performing scheduled maintenance. We should be back online shortly.',
});

i18next.addResources('pt', NAMESPACE, {
  ERROR_TITLE: 'Erro',
  OOPS: 'Oops!',
  GO_BACK: 'voltar ao início',
  NOT_FOUND: 'Página não encontrada',
  MAINTENANCE_PAGE_TITLE: 'Em mantimento',
  MAINTENANCE_TITLE: 'Temporariamente fora de serviço para manutenção',
  MAINTENANCE_DESCRIPTION:
    'Estamos realizando manutenção programada. Em breve estaremos online novamente.',
});

export const useTranslation = () =>
  usei18nextTranslation([NAMESPACE, 'GENERAL']);
